import { render, staticRenderFns } from "./CurriculumVideos.vue?vue&type=template&id=2d467fea&"
import script from "./CurriculumVideos.vue?vue&type=script&lang=js&"
export * from "./CurriculumVideos.vue?vue&type=script&lang=js&"
import style0 from "./CurriculumVideos.vue?vue&type=style&index=0&id=2d467fea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports